export const RUN_STATE_FALLBACK_MS = 3000
export const RUN_STATE_RECONCILE_MS = 12_000
export const RUN_STATE_BACKOFF_MAX_MS = 20_000

/** After a failed run-state fetch: 3s → 10s → 20s, never stop. Reset to FALLBACK on success. */
export function nextRunStateBackoffMs(currentMs: number): number {
  if (currentMs < 10_000) return 10_000
  return RUN_STATE_BACKOFF_MAX_MS
}

export function runStatePollDelayMs(args: {
  failed: boolean
  backoffMs: number
  cableConnected: boolean
  streaming: boolean
}): number {
  if (args.failed) return args.backoffMs
  if (args.cableConnected && args.streaming) return RUN_STATE_RECONCILE_MS
  return RUN_STATE_FALLBACK_MS
}
